//import axios from 'axios';
//.env.REACT_APP_API_PATH ||
// process.env.REACT_CTX_API_PATH ||
//process.env.REACT_APP_CTX_ENV ||
// const client = axios.create({
//   baseURL: apiPath,
// });

import { Recommendation } from './services/Contexture/Recommendation';
import { Rejected } from './services/Contexture/Rejected';
import { Metadata } from './services/Contexture/Metadata';
import { Watchlist } from './services/Contexture/Watchlist';
import { Search } from './services/Contexture/Search';
import { MSTeams } from './services/Contexture/MSTeams';
import { Notification } from './services/Contexture/Notification';
import { Slack } from './services/Contexture/Slack';
import { Auth } from './services/Contexture/Auth';
import { Profile } from './services/Contexture/Profile';
import { Tag } from './services/Contexture/Tag';
import { Content } from './services/Contexture/Content';
import { Social } from './services/Contexture/Social';
import { Technologies } from './services/application/Technologies';
import { UserProfiles } from './services/application/UserProfiles';
import { NamedQuery } from './services/Contexture/NamedQuery';
import { Jira } from './services/Contexture/Jira';

const env = process.env.REACT_APP_ENV; //dev

// // Slack Config
const slack_dev_redirect_url =
  'https://dev1.contexture.ai/services/social/slack/authorize';
const slack_prod_redirect_url =
  'https://billwatch.contexture.ai/services/social/slack/authorize';

// // Slack Client IDs
const slack_dev_client_id = '325462627205.3326589578003';
const slack_prod_client_id = '325462627205.3326589578003'; // update when prod ID differs

// // Microsoft Teams Config
const msteams_dev_client_id = '993dcd77-e8fb-4347-a32f-13a66a8abb86';
const msteams_prod_client_id = '9dbdf14e-03f0-4bca-8317-fc1fcb6704ff';
const msteams_dev_redirect_url =
  'https://dev1.contexture.ai/services/social/msteams/authorize';
const msteams_prod_redirect_url =
  'https://billwatch.contexture.ai/services/social/msteams/authorize';

// // API Path Configs
// const api_path_dev = 'https://dev.securitybulldog.com/ctx/request.php';
// const api_path_prod = 'https://securitybulldog.com/ctx/request.php';
// const ctx_api_path_dev = 'https://dev1.contexture.ai/services';
// const ctx_api_path_prod = 'https://billwatch.contexture.ai/services';

// const endpoints = (env) => {
//   if (env === 'dev') {
//     return {
//       apiPath: api_path_dev,
//       ctxApiPath: ctx_api_path_dev,
//     };
//   } else if (env === 'prod') {
//     return {
//       apiPath: api_path_prod,
//       ctxApiPath: ctx_api_path_prod,
//     };
//   }
// };

// const { ctxApiPath, apiPath } = endpoints(env);

const dateToday = () => {
  const today = new Date();
  return `${today.getFullYear().toString()}-${
    (today.getMonth() + 1).toString().length === 1
      ? '0' + (today.getMonth() + 1).toString()
      : (today.getMonth() + 1).toString()
  }-${
    today.getDate().toString().length === 1
      ? '0' + today.getDate().toString()
      : today.getDate().toString()
  }`;
};
const clearSession = async () => {
  try {
    return await Auth.logout();
  } catch (error) {
    console.error('Clear session error:', error);

    return null;
  }
};

const removeFromRejectList = async (id, profileId) => {
  try {
    return await Rejected.removeDocument(id, { profileId });
  } catch (error) {
    console.error('Remove from reject list error:', error);

    return null;
  }
};

const getProfile = async (user) => {
  try {
    return await Profile.fetchProfile(user);
  } catch (error) {
    console.error('Get profile error:', error);

    return null;
  }
};

const getRecommendationParameters = async (params) => {
  try {
    return await Profile.getRecommendationParameters(params);
  } catch (error) {
    console.error('Get recommendation parameters error:', error);
    throw error;
  }
};

const saveRecommendationParameters = async (data, params) => {
  try {
    return await Profile.setRecommendationParameters(data, params);
  } catch (error) {
    throw error;
  }
};

const getPrefilters = async (params) => {
  try {
    return await Profile.fetchPrefilters(params);
  } catch (error) {
    console.error('Get recommendation parameters error:', error);
    throw error;
  }
};


const savePrefilters = async (criteria, params) => {
  try {
    const prefiltersData = {
      criteria: criteria?.children?.length ? [criteria] : null,
    };
    return await Profile.createOrUpdatePrefilters(prefiltersData, params);
  } catch (error) {
    throw error;
  }
};

const getUserTags = async () => {
  try {
    return await Tag.getDocumentTags();
  } catch (error) {
    console.error('Get user tags error:', error);
    return [];
  }
};

const getTags = async (profileId) => {
  try {
    return await Tag.getDocumentTags({ profile: profileId });
  } catch (error) {
    console.error('Get tags error:', error);
    return [];
  }
};
/**
 * Add/Delete Tags at Contexture for a document
 * @param {string} action - `remove` or `add`
 * @param {string} docId - Document ID
 * @param {string} profileId - The profile ID,
 * @param {string[]} tags - Array of Tags [strings]
 * @public
 */
const updateTags = async (action, docId, profileId, tags) => {
  try {
    const result = await Profile.createOrUpdateTags({
      action,
      docId,
      profileId,
      tags,
    });

    // Clear tags cache for this profile since tags were updated
    clearTagsCache(profileId);

    return result;
  } catch (error) {
    console.error('Update tags error:', error);

    return null;
  }
};

const searchProfileTerms = async (type, search) => {
  try {
    return await Profile.fetchCustomTerms({ type, search });
  } catch (error) {
    console.error('Search profile terms error:', error);
    return [];
  }
};

const searchChildTerms = async (type, search) => {
  try {
    return await Profile.fetchCustomTerms({ type, search, child: true });
  } catch (error) {
    console.error('Search child terms error:', error);
    return [];
  }
};

const updateCustomTerms = async (profileId, terms, action) => {
  try {
    return await Profile.createOrUpdateCustomTerms({
      profile: profileId,
      terms: terms.join(','),
      action,
    });
  } catch (error) {
    console.error('Update custom terms error:', error);

    return null;
  }
};

const postBuddyPressProfileTag = (action, type, terms) => {
  // const cfg = {
  //   action: `custom-tag-${action}`,
  //   type,
  //   terms: terms.join(','),
  //   env,
  // };
  // let params = new URLSearchParams(cfg).toString();
  // return fetch(`${apiPath}?${params}`, {
  //   credentials: 'include',
  //   mode: 'cors',
  // }).then((res) => res.json());
};

const getDocList = async (
  profile,
  list,
  sort_by,
  first_result = 1,
  max_results = 10,
  include_tags
) => {
  const inputData = {
    first_result,
    max_results,
    include_list_status: true,
  };
  if (include_tags && include_tags.length)
    inputData.include_tags = include_tags.join(',');
  if (sort_by && sort_by.length) inputData.sort_by = sort_by.join(',');

  // Add profile to inputData if provided
  if (profile) {
    inputData.profileId = profile;
  }

  // Use throttler to prevent API overload
  return await requestThrottler.throttle(async () => {
    switch (list) {
      case 'watchlist':
        return Watchlist.fetchAll(inputData);
      case 'recommendations':
        return Recommendation.fetchAll(inputData);
      case 'rejectlist':
        return Rejected.fetchAll(inputData);
      default:
        return {};
    }
  });
};

const getDoc = async (id, repositoryId, profileIn, template) => {
  try {
    const profile =
      typeof profileIn !== 'undefined' && profileIn.profileId
        ? profileIn.profileId
        : undefined;

    const params = {};
    if (profile) params.profile = profile;
    if (template) params.template = template;

    let result;
    if (repositoryId) {
      result = await Content.getDocumentFromRepository(
        repositoryId,
        id,
        params
      );
    } else {
      result = await Content.getDocument(id, params);
    }

    // Convert blob to text if needed
    let textContent = result;
    if (result instanceof Blob) {
      textContent = await result.text();
    }

    return {
      status: 200,
      response: textContent,
    };
  } catch (error) {
    console.error('Get document error:', error);

    return {
      status: error.response?.status || 500,
      response: null,
    };
  }
};

const getDocMeta = async (id) => {
  try {
    return await Content.getDocumentMetadata(id);
  } catch (error) {
    console.error('Get document metadata error:', error);

    return null;
  }
};

const getMoreLikeThis = async (docsIdArr, profilePrimary, profileSecondary) => {
  const setTimeoutAsync = (cb, delay) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(cb());
      }, delay);
    });

  const pollStatus = async (handle, params) => {
    return await setTimeoutAsync(async () => {
      try {
        const pollResult = await Recommendation.getMoreLikeThisStatus(
          handle,
          params
        );

        if (pollResult && pollResult.status === 'RUNNING') {
          return pollStatus(handle, params);
        }

        return pollResult;
      } catch (error) {
        console.error('Polling API Error:', error);
        return null;
      }
    }, 3000);
  };

  try {
    const moreLikeThisData = {
      numSimilarDocs: 10,
      sourceRepositoryId: profilePrimary.repositoryId,
      targetRepositoryId: profileSecondary.repositoryId,
      likeThisSourceDocumentIds: docsIdArr,
    };

    const params = {
      profileId: profilePrimary.profileId,
    };

    // Start the "more like this" process
    const initiateResponse = await Recommendation.initiateMoreLikeThis(
      moreLikeThisData,
      params
    );

    if (
      initiateResponse &&
      initiateResponse.status === 'RUNNING' &&
      initiateResponse.handle
    ) {
      const statusResult = await pollStatus(initiateResponse.handle, params);

      if (
        statusResult &&
        statusResult.status === 'COMPLETE' &&
        statusResult.handle
      ) {
        // Get final results
        return await Recommendation.getMoreLikeThisResult(
          statusResult.handle,
          params
        );
      }
    }

    return initiateResponse;
  } catch (error) {
    console.error('More like this error:', error);

    return null;
  }
};

const postMitreSearch = ({ profileId }, docTypes, platforms, terms) => {
  const inputData = { criteria: { type: 'and', children: [] } };
  if (docTypes && docTypes.length) {
    inputData.criteria.children.push({
      type: 'terms',
      fieldName: 'objectType',
      values: docTypes,
    });
  }
  if (platforms && platforms.length) {
    inputData.criteria.children.push({
      type: 'or',
      children: [
        {
          type: 'terms',
          fieldName: 'x-mitre-platforms',
          values: platforms,
        },
        {
          type: 'not',
          criteria: {
            type: 'exists',
            fieldName: 'x-mitre-platforms',
          },
        },
      ],
    });
  }
  if (terms && terms !== '') {
    inputData.criteria.children.push({
      type: 'match',
      fieldName: 'text',
      value: terms,
    });
  }

  return Search.search(inputData, { profile: profileId });
};
const postFindMitreRelationships = ({ profileId }, source, target) => {
  const date = dateToday();
  const inputData = JSON.stringify({
    criteria: {
      type: 'and',
      children: [
        {
          type: 'terms',
          fieldName: 'objectType',
          values: ['relationship'],
        },
        {
          type: 'or',
          children: [
            {
              type: 'terms',
              fieldName: 'source_ref',
              values: [source],
            },
            {
              type: 'terms',
              fieldName: 'target_ref',
              values: [target],
            },
          ],
        },
      ],
    },
  });

  return Search.search(inputData, { profile: profileId });
};
const postDocsByIds = ({ profileId }, docIds, includeFields) => {
  let inputData = {
    criteria: {
      type: 'id',
      values: docIds,
    },
  };
  if (includeFields) {
    inputData['includeFields'] = includeFields;
  }
  inputData = JSON.stringify(inputData);

  return Search.search(inputData, { profile: profileId });
};
const getCVEgetCveOrKve = ({ repositoryId, profileId }, onlyKve) => {
  let input = {
    criteria: {
      type: 'and',
      children: [
        {
          type: 'terms',
          fieldName: 'objectType',
          values: ['vulnerability'],
        },
      ],
    },
  };

  if (onlyKve) {
    input.criteria.children.push({
      type: 'terms',
      fieldName: 'isKev',
      values: ['true'],
    });
  }

  const inputData = JSON.stringify(input);

  const params = {
    profileId,
    repositoryId,
    first_result: 1,
    max_results: 20,
    sort_by: 'publishDate-',
  };

  return Search.search(inputData, params);
};

const postCVERecommendations = ({ profileId }) => {
  const date = dateToday();

  const inputData = JSON.stringify({
    // includeFields: [
    //   'title',
    //   'url',
    //   'publishDate',
    //   'source',
    //   'references',
    //   'score',
    // ],
    criteria: {
      type: 'and',
      children: [
        {
          type: 'terms',
          fieldName: 'objectType',
          values: ['vulnerability'],
        },
        {
          type: 'range',
          fieldName: 'publishDate',
          lte: date,
        },
      ],
    },
  });

  return Search.search(inputData, { profile: profileId });
};

// Cache for metadata fields to prevent excessive API calls
const metadataCache = new Map();
// Cache for tags to prevent duplicate API calls with same profile ID
const tagsCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

// Request throttling to prevent API overload
class RequestThrottler {
  constructor(maxConcurrent = 3, delay = 100) {
    this.maxConcurrent = maxConcurrent;
    this.delay = delay;
    this.activeRequests = 0;
    this.queue = [];
  }

  async throttle(requestFn) {
    return new Promise((resolve, reject) => {
      this.queue.push({ requestFn, resolve, reject });
      this.processQueue();
    });
  }

  async processQueue() {
    if (this.activeRequests >= this.maxConcurrent || this.queue.length === 0) {
      return;
    }

    const { requestFn, resolve, reject } = this.queue.shift();
    this.activeRequests++;

    try {
      const result = await requestFn();
      resolve(result);
    } catch (error) {
      reject(error);
    } finally {
      this.activeRequests--;
      // Add delay before processing next request
      setTimeout(() => {
        this.processQueue();
      }, this.delay);
    }
  }
}

// Global request throttler instance
const requestThrottler = new RequestThrottler(5, 10); // Max 10 concurrent requests, 10ms delay

// Throttled version of Profile.fetchTags with caching
const fetchTagsThrottled = async (params, reset = false) => {
  const profileId = params?.profileId;
  const cacheKey = `tags-${profileId}`;
  const now = Date.now();

  // Check if we have cached data and it's not expired
  if (tagsCache.has(cacheKey)) {
    const cachedData = tagsCache.get(cacheKey);
    if ((now - cachedData.timestamp < CACHE_DURATION) && !reset) {
      return cachedData.data;
    } else {
      // Remove expired cache entry
      tagsCache.delete(cacheKey);
    }
  }

  try {
    const result = await requestThrottler.throttle(async () => {
      return await Tag.getDocumentTags(params);
    });

    // Cache the result with timestamp
    tagsCache.set(cacheKey, {
      data: result,
      timestamp: now,
    });

    // Clean up old cache entries (keep only last 20 entries)
    if (tagsCache.size > 20) {
      const entries = Array.from(tagsCache.entries());
      entries.sort((a, b) => a[1].timestamp - b[1].timestamp);
      // Remove oldest entries
      entries.slice(0, entries.length - 20).forEach(([key]) => {
        tagsCache.delete(key);
      });
    }

    return result;
  } catch (error) {
    console.error('Error fetching tags:', error);
    return { status: 500, response: [] };
  }
};

// Function to clear tags cache (useful when tags are updated)
const clearTagsCache = (profileId = null) => {
  if (profileId) {
    tagsCache.delete(`tags-${profileId}`);
  } else {
    tagsCache.clear();
  }
};

const getFieldsMeta = async (repositoryId, profile) => {
  const cacheKey = `${repositoryId}-${profile}`;
  const now = Date.now();

  // Check if we have cached data and it's not expired
  if (metadataCache.has(cacheKey)) {
    const cachedData = metadataCache.get(cacheKey);
    if (now - cachedData.timestamp < CACHE_DURATION) {
      return cachedData.data;
    } else {
      // Remove expired cache entry
      metadataCache.delete(cacheKey);
    }
  }

  const params = {
    repositoryId,
    profile,
    env,
  };

  try {
    // Use throttler to prevent API overload
    const result = await requestThrottler.throttle(async () => {
      return await Metadata.fetchFields(repositoryId, params);
    });

    // Cache the result with timestamp
    metadataCache.set(cacheKey, {
      data: result,
      timestamp: now,
    });

    // Clean up old cache entries (keep only last 10 entries)
    if (metadataCache.size > 10) {
      const entries = Array.from(metadataCache.entries());
      entries.sort((a, b) => a[1].timestamp - b[1].timestamp);
      // Remove oldest entries
      entries.slice(0, entries.length - 10).forEach(([key]) => {
        metadataCache.delete(key);
      });
    }

    return result;
  } catch (error) {
    console.error('Metadata fetch error:', error);
    throw error;
  }
};

const setPodcastProfilePrefilters = async (profileId) => {
  try {
    const prefiltersData = {
      criteria: [
        {
          type: 'terms',
          fieldName: 'objectType',
          values: ['episode'],
        },
      ],
    };
    return await Profile.createOrUpdatePrefilters(prefiltersData, {
      profileId,
    });
  } catch (error) {
    console.error('Set podcast profile prefilters error:', error);

    return null;
  }
};

const getSlackChannels = async () => {
  try {
    return await Slack.getChannels();
  } catch (error) {
    return [];
  }
};

const setSlackChannel = async (channelIds) => {
  try {
    await Slack.createOrUpdateChannels({ channelIds });
    return true;
  } catch (error) {
    return false;
  }
};

const isSlackAvailable = async () => {
  try {
    return await Slack.isSlackAvailable();
  } catch (error) {
    return { available: false };
  }
};

const slackShare = async (repositoryId, documentId, channelId) => {
  try {
    return await Slack.share({
      repositoryId,
      documentId,
      channelId,
    });
  } catch (error) {
    console.error('Slack share error:', error);

    return null;
  }
};

const slackDeauthorize = async () => {
  try {
    await Slack.deauthorize();
    return true;
  } catch (error) {
    return false;
  }
};

const facebookShare = async (repositoryId, documentId, profileId) => {
  try {
    return await Social.shareFacebook(repositoryId, documentId, {
      profileId,
    });
  } catch (error) {
    console.error('Facebook share error:', error);

    return null;
  }
};

const linkedinShare = async (repositoryId, documentId, profileId) => {
  try {
    return await Social.shareLinkedIn(repositoryId, documentId, {
      profileId,
    });
  } catch (error) {
    console.error('LinkedIn share error:', error);

    return null;
  }
};

const twitterShare = async (repositoryId, documentId, profileId) => {
  try {
    return await Social.shareTwitter(repositoryId, documentId, {
      profileId,
    });
  } catch (error) {
    console.error('Twitter share error:', error);

    return null;
  }
};

const emailShare = async (repositoryId, documentId) => {
  try {
    return await Social.shareEmail(repositoryId, documentId);
  } catch (error) {
    console.error('Email share error:', error);

    return 'fail';
  }
};

const searchDoc = async (repositoryId, documentID) => {
  try {
    return await Search.getDocumentFromRepository(repositoryId, documentID, {});
  } catch (error) {
    console.error('Search document error:', error);

    return null;
  }
};

const slackRedirect = () => {
  if (env === 'prod') return encodeURI(slack_prod_redirect_url);
  return encodeURI(slack_dev_redirect_url);
};

const teamsRedirect = () => {
  if (env === 'prod') return encodeURI(msteams_prod_redirect_url);
  return encodeURI(msteams_dev_redirect_url);
};

const teamsClientId = () => {
  if (env === 'prod') return msteams_prod_client_id;
  return msteams_dev_client_id;
};

const slackClientId = () => {
  if (env === 'prod') return slack_prod_client_id;
  return slack_dev_client_id;
};

const multiSearch = async (
  repos,
  terms,
  queryHandle,
  first_result = 1,
  max_results = 10
) => {
  try {
    let inputData = {
      queryHandle,
      criteria: {
        type: 'and',
        children: [
          {
            type: 'terms',
            fieldName: 'objectType',
            values: [
              'article',
              'vulnerability',
              'episode',
              'x-mitre-tactic',
              'attack-pattern',
              'course-of-action',
              'intrusion-set',
              'malware',
              'tool',
              'x-mitre-data-source',
              'x-mitre-data-component',
              'identity',
            ],
          },
          {
            type: 'and',
            children: [
              { type: 'range', fieldName: 'publishDate', gt: '2017-01-01' },
              { type: 'match', fieldName: 'text', value: terms },
            ],
          },
        ],
      },
      repositoryIds: repos,
    };

    if (queryHandle !== null) {
      inputData = { queryHandle };
    }

    return await Search.multiSearch(inputData, {
      first_result,
      max_results: 10,
    });
  } catch (error) {
    console.error('Multi search error:', error);

    return null;
  }
};

//user Onboards
const postUserOnboard = (type, data) => {
  // const date = dateToday();
  // const inputData = JSON.stringify(data);
  // const cfg = {
  //   action: 'post-user-onboard',
  //   type: type,
  //   inputData,
  //   env,
  // };
  // let params = new URLSearchParams(cfg).toString();
  // return fetch(`${apiPath}?${params}`, {
  //   credentials: 'include',
  //   mode: 'cors',
  // }).then((res) => res.json());
};

const msteamDeauthorize = async () => {
  try {
    await MSTeams.deauthorize();
    return true;
  } catch (error) {
    return false;
  }
};

const isMsteamsAvailable = async () => {
  try {
    return await MSTeams.isMSTeamsAvailable();
  } catch (error) {
    return { available: false };
  }
};

const getMsteams = async () => {
  try {
    return await MSTeams.getTeams();
  } catch (error) {
    return [];
  }
};

const getMsteamChannels = async (teamId) => {
  try {
    return await MSTeams.getChannels({ teamId });
  } catch (error) {
    return [];
  }
};

const setMsteamChannel = async (channelIds, teamId) => {
  try {
    await MSTeams.createOrUpdateChannels({
      teamId,
      channelIds: channelIds,
    });
    return true;
  } catch (error) {
    return false;
  }
};

const msteamShare = async (repositoryId, documentId, channelId) => {
  try {
    return await MSTeams.share({
      repositoryId,
      documentId,
      channelId,
    });
  } catch (error) {
    console.error('MSTeams share error:', error);

    return null;
  }
};

const getNotificationPreferences = async () => {
  try {
    return await Notification.getPreferences();
  } catch (error) {
    console.error('Get notification preferences error:', error);
    return {};
  }
};

const setNotificationPreferences = async (data) => {
  try {
    return await Notification.updatePreferences(data);
  } catch (error) {
    console.error('Set notification preferences error:', error);

    return null;
  }
};

// Technologies service functions
const getAllTechnologies = async (params) => {
  try {
    return await Technologies.fetchAll(params);
  } catch (error) {
    console.error('Get all technologies error:', error);
    return null;
  }
};

const getTechnologiesByType = async (type, params) => {
  try {
    return await Technologies.fetchByType(type, params);
  } catch (error) {
    console.error('Get technologies by type error:', error);
    return null;
  }
};

const getTechnologyByNameAndType = async (name, type, params) => {
  try {
    return await Technologies.fetchByNameAndType(name, type, params);
  } catch (error) {
    console.error('Get technology by name and type error:', error);
    return null;
  }
};

const createTechnology = async (technology, params) => {
  try {
    return await Technologies.create(technology, params);
  } catch (error) {
    console.error('Create technology error:', error);
    return null;
  }
};

const updateTechnology = async (name, type, updates, params) => {
  try {
    return await Technologies.update(name, type, updates, params);
  } catch (error) {
    console.error('Update technology error:', error);
    return null;
  }
};

const deleteTechnology = async (tech_id, params) => {
  try {
    return await Technologies.delete(tech_id, params);
  } catch (error) {
    console.error('Delete technology error:', error);
    return null;
  }
};

// UserProfiles service functions
const getAllUserProfiles = async (params) => {
  try {
    return await UserProfiles.fetchAll(params);
  } catch (error) {
    console.error('Get all user profiles error:', error);
    return null;
  }
};

const getUserProfile = async (userId, params) => {
  try {
    return await UserProfiles.fetchByUserId(userId, params);
  } catch (error) {
    console.error('Get user profile error:', error);
    return null;
  }
};

const createUserProfile = async (profileData, params) => {
  try {
    return await UserProfiles.create(profileData, params);
  } catch (error) {
    console.error('Create user profile error:', error);
    return null;
  }
};

const updateUserProfile = async (userId, updates, params) => {
  try {
    return await UserProfiles.update(userId, updates, params);
  } catch (error) {
    console.error('Update user profile error:', error);
    return null;
  }
};

const deleteUserProfile = async (userId, params) => {
  try {
    return await UserProfiles.delete(userId, params);
  } catch (error) {
    console.error('Delete user profile error:', error);
    return null;
  }
};

// Named Query service functions
const getNamedQueries = async (params) => {
  try {
    return await NamedQuery.getAll(params);
  } catch (error) {
    console.error('Get named queries error:', error);
    return [];
  }
};

const getMaxNamedQueries = async (params) => {
  try {
    return await NamedQuery.getMax(params);
  } catch (error) {
    return null;
  }
};

const getNamedQueryByName = async (name, params) => {
  try {
    return await NamedQuery.getByName(name, params);
  } catch (error) {
    throw error;
  }
};

const createNamedQuery = async (namedQueryData, params) => {
  try {
    const response = await NamedQuery.create(namedQueryData, params);
    if (response && response.success === false) {
      throw new Error(response.errorMessage || 'Failed to create named query');
    }
    return response;
  } catch (error) {
    throw error;
  }
};

const updateNamedQuery = async (name, namedQueryData, params) => {
  try {
    const response = await NamedQuery.update(name, namedQueryData, params);
    if (response && response.success === false) {
      throw new Error(response.errorMessage || 'Failed to update named query');
    }
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteNamedQuery = async (name, params) => {
  try {
    const response = await NamedQuery.delete(name, params);
    if (response && response.success === false) {
      throw new Error(response.errorMessage || 'Failed to delete named query');
    }
    return response;
  } catch (error) {
    throw error;
  }
};

const advanceMultiSearch = async (
  repos,
  criteria,
  sortBy = null,
  queryHandle,
  includeListStatus = false,
  first_result = 1,
  max_results = 10
) => {
  try {
    let inputData = {
      queryHandle,
      criteria: criteria,
      repositoryIds: repos,
    };

    if (queryHandle !== null) {
      inputData = { queryHandle };
    }

    return await Search.multiSearch(inputData, {
      first_result,
      max_results: max_results,
      sort_by: sortBy,
      include_list_status: includeListStatus,
    });
  } catch (error) {
    console.error('Multi search error:', error);
    return null;
  }
};

export {
  getProfile,
  getUserTags,
  getTags,
  updateTags,
  updateCustomTerms,
  getDocList,
  getDoc,
  getDocMeta,
  clearSession,
  getFieldsMeta,
  getMoreLikeThis,
  postMitreSearch,
  postFindMitreRelationships,
  postCVERecommendations,
  postDocsByIds,
  removeFromRejectList,
  postBuddyPressProfileTag,
  searchProfileTerms,
  setPodcastProfilePrefilters,
  getSlackChannels,
  setSlackChannel,
  isSlackAvailable,
  slackShare,
  slackDeauthorize,
  facebookShare,
  linkedinShare,
  twitterShare,
  emailShare,
  searchDoc,
  slackRedirect,
  multiSearch,
  advanceMultiSearch,
  postUserOnboard,
  searchChildTerms,
  msteamDeauthorize,
  isMsteamsAvailable,
  getMsteams,
  getMsteamChannels,
  setMsteamChannel,
  msteamShare,
  teamsRedirect,
  teamsClientId,
  slackClientId,
  getNotificationPreferences,
  setNotificationPreferences,
  getCVEgetCveOrKve,
  fetchTagsThrottled,
  clearTagsCache,
  // Technologies
  getAllTechnologies,
  getTechnologiesByType,
  getTechnologyByNameAndType,
  createTechnology,
  updateTechnology,
  deleteTechnology,
  // UserProfiles
  getAllUserProfiles,
  getUserProfile,
  createUserProfile,
  updateUserProfile,
  deleteUserProfile,
  // NamedQueries
  getNamedQueries,
  getMaxNamedQueries,
  getNamedQueryByName,
  createNamedQuery,
  updateNamedQuery,
  deleteNamedQuery,
  getRecommendationParameters,
  saveRecommendationParameters,
  getPrefilters,
  savePrefilters,
  // Service Classes
  Content,
  Social,
  Technologies,
  UserProfiles,
  NamedQuery,
  Jira,
};
